import * as types from './types'
import {RSAA} from "redux-api-middleware";

export function getGameInstance(instance_id) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                types.GAME_INSTANCE_LOAD,
                types.GAME_INSTANCE_LOAD_SUCCESS,
                types.GAME_INSTANCE_LOAD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}

export function createGame(game_data) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/create`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                types.GAME_INSTANCE_CREATE,
                types.GAME_INSTANCE_CREATE_SUCCESS,
                types.GAME_INSTANCE_CREATE_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(game_data)

        },
        auth: true
    };
}

export function editGame(instance_id, game_data) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}`,
            method: 'PATCH',
            headers: types.defaultHeaders,
            types: [
                types.GAME_INSTANCE_UPDATE,
                types.GAME_INSTANCE_UPDATE_SUCCESS,
                types.GAME_INSTANCE_UPDATE_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(game_data)

        },
        auth: true
    };
}

export function sendInput(instance_id, data) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}/input`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                types.GAME_INSTANCE_INPUT,
                types.GAME_INSTANCE_INPUT_SUCCESS,
                types.GAME_INSTANCE_INPUT_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify({ input: data })
        },
        auth: true
    };
}

export function discardGameInstance(instance_id) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}`,
            method: 'DELETE',
            headers: types.defaultHeaders,
            types: [
                types.GAME_INSTANCE_DISCARD,
                types.GAME_INSTANCE_DISCARD_SUCCESS,
                types.GAME_INSTANCE_DISCARD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}
